import React from "react";
import {Row as BootStrapRow} from "react-bootstrap";

type Props = {
  children: React.ReactNode;

  id?: string;
  className?: string;
};

const Row = (props: Props) => {
  return (
    <BootStrapRow id={props.id} className={props.className}>
      {props.children}
    </BootStrapRow>
  );
};

export default Row;
